module.exports = __webpack_public_path__ + "img/humedad_blue.e24807b8.svg";